import PropTypes from "prop-types";

import React, { useMemo } from "react";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";

import {
  Button,
  Checkbox,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

const FilterNew = ({
  groupFilter,
  handleItemClick,
  openArray,
  handleFilterDescNew,
  FilterDataList
}) => {
  const { ActiveNavBarFilter } = useSelector((store) => store.NavBarReducer);
  const getFewCategory = (name) => {
    return (
      name === "CATEGORY" ||
      name === "LINE OF BUSINESS" ||
      name === "STYLE KARAT" ||
      name === "STYLE COLLECTION" ||
      name === "STYLE COLOR"
    );
  };

  const MemoActiveFilterData = useMemo(() => {
    const ActiveFilterData = [];
    if (FilterDataList?.length) {
      for (const filterInfo of FilterDataList) {
        if (filterInfo.IS_CHECKED == 1 && filterInfo.FILTER_TYPE == "LOV") {
          ActiveFilterData.push(filterInfo);
        }
      }
    }

    return ActiveFilterData;
  }, [FilterDataList?.length, JSON.stringify(FilterDataList?.reduce((acc, currObj) => {
    if (currObj?.IS_CHECKED == 1) {
      acc += currObj?.FILTER_DESC;
    }

    return acc;
  }, ""))])

  return (
    <List 
      sx={{ 
        width: "100%", 
        maxWidth: 360,
        "& > #active-filter-bj": {
          textAlign: "left",
          paddingRight: "6px"
        }
      }} 
      component="nav"
    >
      {
        MemoActiveFilterData.length ? (
          <div id="active-filter-bj">
            <Typography variant="h6" style={{ fontSize: "16px" }}>Active Filter</Typography>
            <Stack direction="row" alignItems="center" flexWrap="wrap" justifyContent="space-between" gap={0.5}>
              {
                MemoActiveFilterData.map((filterInfo) => (
                  <Button
                    key={filterInfo?.FILTER_DESC + "-active-filter"}
                    variant="text"
                    tabIndex={-1}
                    size="small"
                    sx={{
                      background: "#FFFFFF !important",
                      color: "#222222  !important",
                      borderRadius: "4px",
                      fontSize: "11px",
                      paddingLeft: "6px !important",
                      border: "1px solid #94265b"
                    }}
                    endIcon={<ClearIcon />}
                    onClick={() =>
                      handleFilterDescNew(filterInfo, false)
                    }
                  >
                    {filterInfo?.FILTER_DESC}
                  </Button>
                ))
              }
            </Stack>
          </div>
        ) : null
      }

      {groupFilter &&
        Object.entries(groupFilter)
          ?.filter(([name]) => getFewCategory(name))
          ?.map(([name, filterValues], index) => (
            <div key={name}>
              <ListItemButton
                onClick={() => handleItemClick(index)}
                sx={{ pl: 0, pr: 0 }}
              >
                <ListItemText sx={{ fontFamily: "Tenor Sans" }}>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontFamily: ["Tenor Sans"],
                    }}
                  >
                    {name}
                    {"   "}
                    <span style={{ fontWeight: "bold" }}>
                      {filterValues?.filter(
                        (filterInfo) => filterInfo?.IS_CHECKED == 1 && filterInfo.FILTER_TYPE == "LOV"
                      )?.length
                        ? "(" +
                          filterValues?.filter(
                            (filterInfo) => filterInfo?.IS_CHECKED == 1 && filterInfo.FILTER_TYPE == "LOV",
                          )?.length +
                          ")"
                        : null}
                    </span>
                  </Typography>
                </ListItemText>
                {openArray[index] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openArray[index]} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  sx={{
                    "& > li": {
                      paddingRight: "16px",
                      paddingLeft: "4px",
                    },
                    textAlign: "left",
                  }}
                >
                  {filterValues?.filter(
                    (filterInfo) => filterInfo?.IS_CHECKED == 1 && filterInfo.FILTER_TYPE == "LOV"
                  )?.length ? (
                    <Button
                      key={name + "_clear-filter"}
                      variant="text"
                      tabIndex={-1}
                      size="small"
                      sx={{
                        background: "#FFFFFF !important",
                        color: "#222222  !important",
                        borderRadius: "4px",
                        fontSize: "12px",
                        paddingLeft: "12px !important",
                      }}
                      startIcon={<ClearIcon />}
                      onClick={() =>
                        handleFilterDescNew(filterValues?.[0], true)
                      }
                    >
                      Clear
                    </Button>
                  ) : null}
                  {filterValues
                    .filter((filter) => filter.FILTER_TYPE == "LOV")
                    .map((filter) => (
                      <ListItem
                        key={filter.FILTER_DESC}
                        secondaryAction={
                          <Checkbox
                            checked={filter.IS_CHECKED == 1}
                            onChange={() => {
                              handleFilterDescNew(filter);
                            }}
                            size="small"
                            sx={{
                              minWidth: "unset",
                            }}
                            inputProps={{
                              style: {
                                minWidth: "unset",
                              },
                            }}
                          />
                        }
                      >
                        <ListItemButton
                          sx={{ pl: 1, paddingRight: "24px !important" }}
                          // onClick={() => handleFilterDesc(filter)}
                          onClick={() => handleFilterDescNew(filter)}
                        >
                          <ListItemText>
                            <Typography
                              sx={{
                                fontSize: "13px !important",
                                fontFamily: ["Tenor Sans"],
                              }}
                            >
                              {filter.FILTER_DESC}
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    ))}
                </List>
              </Collapse>
            </div>
          ))}
    </List>
  );
};

FilterNew.propTypes = {
  groupFilter: PropTypes.any,
  handleItemClick: PropTypes.func,
  openArray: PropTypes.any,
  handleFilterDescNew: PropTypes.func,
  FilterDataList: PropTypes.any
};

export default FilterNew;
